import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import helpBubbleImage from './img/bubble-icon.png';
import helpPhoneImage from './img/phone-icon.png';

const Help = (props: WithTranslation) => {
    const { t } = props;
    return (
        <div className="help-container">
            <h2 className="header-3 help-title">{t('help_title')}</h2>
            <div className="help-icons-container">
                <div className="help-icon-container">
                    <img
                        src={helpBubbleImage}
                        alt={t('help_bubble_alt_text', { ns: 'accessibility' })}
                    />
                    <a
                        target="_blank"
                        rel="noreferrer"
                        className="standalone-link standalone-link--large help-icon-label"
                        href={t('help_faq_cta_destination')}
                    >
                        {t('help_faq_cta_title')}
                    </a>
                </div>
                <div className="help-icon-container">
                    <img
                        src={helpPhoneImage}
                        alt={t('help_phone_alt_text', { ns: 'accessibility' })}
                    />
                    <div className="help-icon-label">
                        <div className="body-large">{t('help_phone_number')}</div>
                        <div className="body-small">{t('help_phone_schedule')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withTranslation()(Help);
